export function camelize(str) {
    return (str || "").toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

export function getOrganizationName(organization, project) {
    const metadata = {
        Organization: (organization || {}).name,
        Project: project
            ? `${(project || {}).taxRegistrationNumber} - ${(project || {}).name}`
            : "",
        Url: window.location.href,
    };
    const metadataString = (JSON.stringify(metadata, null, 2) || "").replace(/{|}|"/gi, "");
    return metadataString;
}

export function snakeCaseToPascalCase(str, prefix = "", plural = "") {
    const camelize = str.replace(/_\w/g, (m) => m[1].toUpperCase());
    const pascalCase = camelize.substring(0, 1).toUpperCase() + camelize.substring(1);
    return `${prefix}${pascalCase}${plural}`;
}
